import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { RootState } from 'Reducers';
import {
  exerciseContentRequested,
  selectExerciseContentEntry,
  type ExerciseContentEntry,
} from 'Reducers/exerciseProgressReducer';

/**
 * The exercise the server holds under `slug`: `loading` until the read answers, then `loaded`
 * with the content or `failed`. It is read on mount unless it is already in hand (a failed read
 * is tried again on the next mount), so the play screen plays the content the overview showed.
 */
export function useExerciseContent(slug: string): ExerciseContentEntry {
  const dispatch = useDispatch();
  const entry = useSelector((s: RootState) => selectExerciseContentEntry(s, slug));
  const needsRead = entry === undefined || entry.status === 'failed';
  const needsReadRef = React.useRef(needsRead);
  needsReadRef.current = needsRead;
  React.useEffect(() => {
    if (needsReadRef.current) dispatch(exerciseContentRequested({ slug }));
  }, [dispatch, slug]);
  return entry ?? { status: 'loading', content: null };
}
